import React from 'react';
import { CreateActionButton } from '../../components/actions/action-buttons';
import { LinkField, TextDataField } from '../../components/data-fields';
import { TextView } from '../../components/view-fields';
import CrudListView from '../../layout/crud/CrudListView';
import PlainLayout from '../../layout/PlainLayout';
import { metaData } from './metaData';

const ListView: React.FunctionComponent = () => {
  // listing admin
    return (
    <PlainLayout>
      <CrudListView metaData={metaData} actions={[<CreateActionButton />]}>
        <LinkField source="name" label="Name">
          <TextView />
        </LinkField>
        <TextDataField source="email" label="Email"></TextDataField>
        <TextDataField source="phone" label="Phone"></TextDataField>
        <TextDataField source="role" label="Role"></TextDataField>
      </CrudListView>
    </PlainLayout>
  );
};

export default ListView;
